import { useState } from 'react'
import { Redirect } from 'react-router'
import styled from 'styled-components'
import { useAuthContext } from './contexts/AuthContext'
import pulseLogo from '../Assets/pulse_login_logo.svg'
import usernameIcon from '../Assets/usernameIcon.svg'
import passwordIcon from '../Assets/passwordIcon.svg'

function Login() {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const { user, login } = useAuthContext()

    return (
        (!!user && <Redirect to="/" />) || (
            <Container>
                <Logo>
                    <img src={pulseLogo} alt="Pulse" />
                </Logo>
                <Heading>Sign In</Heading>
                <Form>
                    <InputContainer>
                        <Label htmlFor="pulse_username">
                            <img src={usernameIcon} alt="username" />
                        </Label>
                        <InputField
                            type="text"
                            id="pulse_username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Username"
                        />
                    </InputContainer>
                    <InputContainer>
                        <Label htmlFor="pulse_password">
                            <img src={passwordIcon} alt="password" />
                        </Label>
                        <InputField
                            type="password"
                            id="pulse_password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Password"
                        />
                    </InputContainer>
                </Form>

                <Button
                    onClick={() => login(`${username}@pulse.com`, password)}
                >
                    Login
                </Button>
            </Container>
        )
    )
}

const Container = styled.div`
    background-color: #2e2e53;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
`

const Logo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 130px;

    img {
        width: 100%;
    }
`

const Heading = styled.h1`
    text-align: center;
    font-size: 24px;
    margin: 30px auto 15px auto;
    color: #c2c0ce;
`

const Form = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 15px auto;
    max-width: 250px;
    width: 90%;
`

const InputContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 1.5rem 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #c2c0ce;
`

const Label = styled.label`
    margin-right: 10px;
    width: 1.3rem;
    height: 1.3rem;

    img {
        width: 100%;
        margin-bottom: 1px;
    }
`

const InputField = styled.input`
    background: transparent;
    outline: none;
    border: none;
    font-size: 1rem;
    color: #c2c0ce;

    &::placeholder {
        color: rgba(194, 192, 206, 0.62);
    }
`

const Button = styled.button`
    margin-top: 30px;
    width: 90%;
    max-width: 250px;
    outline: none;
    border: none;
    font-size: 1.1rem;
    padding: 15px 20px;
    border-radius: 2px;
    cursor: pointer;
    background-color: #232342;
    color: #c2c0ce;
    transition: all 0.15s ease-in-out;

    &:hover {
        background-color: #39395e;
    }
`

export default Login
